<script setup lang="ts">
import { faArrowRight } from '@fortawesome/pro-light-svg-icons'

defineProps<{
  article: CrystallizeArticle
  dir: 'ltr' | 'rtl'
}>()
</script>

<template>
  <NuxtLink :to="article.path" class="no-underline group grid grid-cols-subgrid col-span-full">
    <div
      class="flex flex-col gap-s py-m rounded-4xl bg-blurple-50 z-[1] pl-l"
      :class="!!article.components?.headerImage ? ['col-span-4 sm:col-span-2 lg:col-span-5 2xl:col-start-2 pr-xs', dir === 'ltr' ? 'sm:-mr-[--gutter]' : 'sm:-ml-[--gutter]'] : 'col-span-full pr-l'"
    >
      <h5 class="title-m" v-text="article.components?.title" />
      <div class="line-clamp-3">
        <CrystallizeRichText v-for="(block, i) in article.components.leadParagraph" :key="i" class="mt-s" :block="block" />
      </div>

      <div class="flex items-center gap-s my-xs">
        <span>Les artikkel</span>

        <Icon :icon="faArrowRight" class="group-hover:translate-x-2 transition-transform" />
      </div>
    </div>

    <CrystallizeClippedImage
      v-if="article.components?.headerImage"
      :image="article.components.headerImage"
      :path="dir === 'ltr' ? 'octagon-right' : 'octagon-left'"
      :class="dir === 'ltr' ? '-ml-l' : '-mr-l'"
      class="z-0 overflow-hidden hidden sm:block col-span-2 lg:col-span-3"
      img-class="group-hover:scale-105 transition-transform size-full object-cover"
    />
  </NuxtLink>
</template>

<style scoped>
a {
  direction: v-bind(dir);

  * {
    direction: ltr;
  }
}
</style>
